module.exports = __webpack_public_path__ + "static/media/bg-reservation.8ac7aa5a.jpg";